import { service } from '../../../service';

const state = {};

const actions = {
  async uploadFiles({ dispatch, commit, rootState }, { documents, folder }) {
    dispatch('alert/uploading', 'Uploading', { root: true });

    const formData = new FormData();
    documents.forEach((document) => {
      console.log(document);
      if (document.value) {
        formData.append('files', document.value);
      }
    });

    var files = await service.post(
      `/documents/${rootState.account.company._id}/${rootState.account.location._id}/${folder}`,
      formData
    );
    dispatch('alert/clearUploading', null, { root: true });

    if (files) {
      documents.forEach((document) => {
        if (document.value) {
          var file = files.find((file) => {
            return file.originalname == document.value.name;
          });
          if (file) {
            document.filename = file.Key;
          }
        }
      });
      return documents;
    } else {
      return null;
    }
  },

  async getURL({ dispatch, commit, rootState }, key) {
    return await service.get(
      `/documents/${rootState.account.company._id}/${rootState.account.location._id}?key=${key}`
    );
  },

  async updateFile({ dispatch, commit, rootState }, { folder, obj }) {},

  async deleteFiles({ dispatch, commit, rootState }, { folder, obj }) {},

  async deleteFile({ dispatch, commit, rootState }, { folder, obj, id }) {},
};

const mutations = {};

export const documents = {
  namespaced: true,
  state,
  actions,
  mutations,
};
